module.exports = __webpack_public_path__ + "img/nexerion_weiss.15f00aaf.svg";